import styled from "styled-components";

export const BenefitsSection = styled.section`
  max-width: 375px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 32px 25px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 515px;
  }
  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 1439px;
    padding: 32px 128px;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 48px;
  }
`;

export const BenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 320px;
  }
`;

export const Trials = styled(BenefitContainer)`
  order: 1;
  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    order: 2;
  }
`;

export const Manage = styled(BenefitContainer)`
  order: 2;
  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    order: 1;
  }
`;

export const Flexible = styled(BenefitContainer)`
  order: 3;
`;

export const BenefitTitle = styled.span`
  text-align: center;
  display: inline-flex;
  font-family: ThemeFontBold;
  font-weight: 700;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
`;

export const BenefitDescription = styled.span`
  text-align: center;
  display: inline-flex;
  font-family: ThemeFontRegular;
  font-weight: 400;
  color: ${({ theme }) => theme.customTheme.palette.grey.light5E};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
`;

export const LoginButton = styled.a<{
  disabled: boolean;
}>`
  order: 4;
  margin-top: 32px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  border-radius: 28px;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
  padding: 14px 24px;
  color: ${({ theme }) => theme.customTheme.palette.white.standard};
  background-color: ${({ theme }) => theme.customTheme.palette.red.standard};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  font-family: ThemeFontRegular;
  filter: brightness(100%);
  transition: filter 200ms ease;

  &:hover {
    filter: brightness(150%);
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.customTheme.palette.grey.standard : theme.customTheme.palette.black.black1};
    max-width: 327px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    display: none;
  }
`;
